import { useNavigate, useParams } from "react-router";
import { useSmartBack } from "../hooks/smartBack";
import { Button, makeStyles, shorthands, tokens, Toast, ToastBody, ToastTitle, Toaster, useId, useToastController } from "@fluentui/react-components";
import { ArrowLeft20Regular } from "@fluentui/react-icons";
import RisikoanalyseFormView from "../components/RisikoanalyseFormView";

const useStyles = makeStyles({
  root: {
    ...shorthands.padding("16px"),
    "@media (min-width: 768px)": {
      ...shorthands.padding("24px"),
    },
  },
  breadcrumb: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
    marginBottom: "12px",
    color: tokens.colorNeutralForeground2,
    fontSize: "0.95rem",
  },
});

const InternalRisikoanalyseFormPage = () => {
  const styles = useStyles();
  const { contactId, token } = useParams<{ contactId: string; token: string }>();
  const navigate = useNavigate();
  const goBack = useSmartBack(contactId ? `/contacts/${contactId}` : "/contacts");
  const toasterId = useId("risikoanalyse-internal-toaster");
  const { dispatchToast } = useToastController(toasterId);

  const handleSubmitSuccess = () => {
    dispatchToast(
      <Toast>
        <ToastTitle>Risikoanalyse gespeichert</ToastTitle>
        <ToastBody>Die eingegebenen Werte sind nun in der Übersicht des Kontakts sichtbar.</ToastBody>
      </Toast>,
      { intent: "success" }
    );
    if (contactId) {
      navigate(`/contacts/${contactId}`);
    }
  };

  return (
    <div className={styles.root}>
      <Toaster toasterId={toasterId} position="top-end" />
      <div className={styles.breadcrumb}>
        <Button
          appearance="subtle"
          size="small"
          icon={<ArrowLeft20Regular />}
          onClick={goBack}
        >
          Zurück zum Kontakt
        </Button>
      </div>
      <RisikoanalyseFormView
        token={token}
        chrome="embedded"
        onSubmitSuccess={handleSubmitSuccess}
      />
    </div>
  );
};

export default InternalRisikoanalyseFormPage;
